module.exports = __webpack_public_path__ + "static/media/julio.9bfcbc56.png";